import { render, staticRenderFns } from "./AssinaturaDialog.vue?vue&type=template&id=dc0a1a26&scoped=true"
import script from "./AssinaturaDialog.vue?vue&type=script&lang=js"
export * from "./AssinaturaDialog.vue?vue&type=script&lang=js"
import style0 from "./AssinaturaDialog.vue?vue&type=style&index=0&id=dc0a1a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0a1a26",
  null
  
)

export default component.exports